const INITIAL_STATE = {
	dados: {},
	lista: [],
	loading: false,
	error: null,
};

// eslint-disable-next-line default-param-last
export function clientRecebimentos(state = INITIAL_STATE, action) {
	switch (action.type) {
		case '@clientRecebimentos/REQUEST':
			return { ...state, loading: true };

		case '@clientRecebimentos/SUCCESS':
			return {
				dados: action.payload.dados.dados,
				lista: action.payload.dados.lista,
				loading: false,
				erro: null,
			};

		case '@clientRecebimentos/FAILURE':
			return {
				dados: {},
				lista: [],
				loading: false,
				erro: action.payload.error,
			};

		default:
			return state;
	}
}
